/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {ItemTextBoxComponent as ɵa} from './src/app/modules/item-text-box/item-text-box.component';